var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/editor-drawer-panel.ts
import "@adornis/base/utilTypes.js";
import "@adornis/buildify/client/components/x-buildify-size-picker.js";
import { RXController } from "@adornis/chemistry/controllers/RXController.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import { XDrawerPanel } from "@adornis/dialog/x-drawer-panel.js";
import { TranslationController } from "@adornis/translation-core/client/translation-controller.js";
import { ContextProvider, createContext } from "@lit/context";
import { html, nothing } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { combineLatest, distinctUntilChanged, filter, startWith } from "rxjs";
import { Contexts } from "../db/enums.js";
import { BaseEditor } from "./editors/Base.js";
import { RenderableConfigFormController } from "./RenderableConfigFormController.js";
import "./types.js";
var EditorDrawerPanel = class extends XDrawerPanel {
  constructor() {
    super(...arguments);
    this.dataContent = new RXController(this, void 0);
    this.editor = new RXController(this, void 0);
    this.globalSettingsClassName = new RXController(this, void 0);
    this.sizeBreakpoints = new RXController(this, void 0);
    this._size = new RXController(this, void 0);
    this._controller = new RXController(
      this,
      void 0
    );
    this.t = new TranslationController(this);
    this._globalSettingsClassNameProvider = new ContextProvider(this, {
      context: createContext(Contexts.GLOBAL_SETTINGS_CLASS_NAME)
    });
  }
  updated(_changedProperties) {
    super.updated(_changedProperties);
    if (this._lastController !== this._controller.value) {
      this._lastController?.hostDisconnected();
      this._lastController = this._controller.value;
    }
  }
  close() {
    super.close(this.dataContent.value);
  }
  cancel() {
    this.close();
  }
  firstUpdated(_changedProperties) {
    super.firstUpdated(_changedProperties);
    requestAnimationFrame(() => {
      const activeElement = document.activeElement;
      if (!activeElement)
        return;
      activeElement.blur();
    });
  }
  connectedCallback() {
    super.connectedCallback();
    this.globalSettingsClassName.observable.pipe(filter(Boolean), distinctUntilChanged()).subscribe((className) => {
      this._globalSettingsClassNameProvider.setValue(className, true);
    });
    combineLatest([this.dataContent.observable, this._size.observable.pipe(startWith(void 0))]).subscribe(
      ([data, size]) => {
        if (!data)
          return;
        this._controller.next(
          new RenderableConfigFormController(this, data, size, {
            error: (instance) => {
            },
            success: (instance) => {
            }
          })
        );
      }
    );
  }
  content() {
    const content = this.dataContent.value;
    const editor = this.editor.value;
    const controller = this._controller.value;
    if (!content || !editor || !controller?.document)
      return html` falsy state `;
    return xComponents(html`
      <x-flex space="lg" padding="md">
        ${this.sizeBreakpoints.value ? html`
              <x-buildify-size-picker
                @value-picked=${(e) => this._size.next(e.detail.value)}
              ></x-buildify-size-picker>
            ` : nothing}
        ${editor({
      content,
      contentController: controller,
      controllerBaseKeyPath: [],
      host: this,
      translation: this.t
    })}
        ${BaseEditor({
      content,
      contentController: controller,
      controllerBaseKeyPath: [],
      host: this,
      translation: this.t
    })}
      </x-flex>
    `);
  }
  static get element_name() {
    return "editor-drawer-panel";
  }
  styles() {
    return [
      ...super.styles(),
      {
        dialog: {
          width: "min(700px, 100%) !important"
        }
      }
    ];
  }
};
__decorateClass([
  property({ attribute: false })
], EditorDrawerPanel.prototype, "dataContent", 2);
__decorateClass([
  property({ attribute: false })
], EditorDrawerPanel.prototype, "editor", 2);
__decorateClass([
  property({ attribute: false })
], EditorDrawerPanel.prototype, "globalSettingsClassName", 2);
__decorateClass([
  property({ attribute: false })
], EditorDrawerPanel.prototype, "sizeBreakpoints", 2);
__decorateClass([
  state()
], EditorDrawerPanel.prototype, "_size", 2);
__decorateClass([
  state()
], EditorDrawerPanel.prototype, "_controller", 2);
__decorateClass([
  state()
], EditorDrawerPanel.prototype, "t", 2);
EditorDrawerPanel = __decorateClass([
  customElement("editor-drawer-panel")
], EditorDrawerPanel);
export {
  EditorDrawerPanel
};
